export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/license/state.js